<div
    class="miles-editable miles-card padded"
    *ngIf="!isEditing && closedDate.Id > 0"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    (click)="edit()"
    [style.cursor]="canEdit ? 'pointer' : 'default'"
>
    <h4>
        Closed Date Info
        <span class="pull-right" *ngIf="canEdit" [hidden]="!isHovered">
            <i class="fa fa-lg fa-edit"></i>
        </span>
    </h4>
    <mt-dynamic-view [config]="viewOnly"></mt-dynamic-view>
    <div class="closed-date-section">
        <h4>Selected Offices</h4>
        <ul class="closed-date-list" *ngIf="closedDate.OfficeClosedDates.length > 0; else noSelectedOffices">
            <li *ngFor="let selectedOffice of closedDate.OfficeClosedDates">
                {{ selectedOffice.Office.Title }}
            </li>
        </ul>
        <ng-template #noSelectedOffices>
            <h5><i>No selected offices</i></h5>
        </ng-template>
    </div>

    <div class="closed-date-section">
        <h4>Excluded Customers</h4>
        <ul class="closed-date-list" *ngIf="closedDate.ExcludedCustomersClosedDates.length > 0; else noExcludedCustomers">
            <li *ngFor="let selectedCustomer of closedDate.ExcludedCustomersClosedDates">
                {{ selectedCustomer.Customer.Name }}
            </li>
        </ul>
        <ng-template #noExcludedCustomers>
            <h5><i>No excluded customers</i></h5>
        </ng-template>
    </div>
</div>
<div *ngIf="isEditing" class="miles-form padded">
    <h4>Closed Date Info</h4>
    <mt-dynamic-form [config]="formObject" (submitted)="formSubmitted($event)">
        <label>Select Offices</label><br />
        <mt-multiselect
            [items]="officeSelectItems"
            [filterMode]="false"
            entity="offices"
            (selectionChanged)="officeSelectionChanged($event)"
        ></mt-multiselect
        ><br /><br />
        <label>Exclude Customers</label><br />
        <mt-multiselect
            [items]="customerSelectItems"
            [filterMode]="false"
            entity="customers"
            (selectionChanged)="customerSelectionChanged($event)"
        ></mt-multiselect>
        <br /><br />
        <button type="submit" mtDisableClickDuringHttpCalls Class="btn btn-flat btn-success">Save</button>
        <button type="button" Class="btn btn-flat btn-default" (click)="cancelClick()">Cancel</button>
    </mt-dynamic-form>
</div>
